export const filterData = (data) => {
  return {
    careProviderFirstName: data?.careProviderFirstName,
    careProviderLastName: data?.careProviderLastName,
    careProviderMpin: data?.careProviderMpin,
    corporateProviderName: data?.corporateProviderName,
    corporateProviderMpin: data?.corporateProviderMpin,
    ipAddress: data?.ipAddress,
    isTechnicalUser: data?.isTechnicalUser,
    optumId: data?.optumId,
    payerId: data?.payerId,
    payerName: data?.payerName,
    taxIdNumber: data?.taxIdNumber,
    userEmail: data?.userEmail,
    userFirstName: data?.userFirstName,
    userLastName: data?.userLastName,
    username: data?.username,
    uuid: data?.uuid,
    permissionCode: data?.permissionCode || [],
    allPermission: data?.allPermission || false,
    userType: data?.userType,
    userStatus: data?.userStatus,
    tpsm: data?.tpsm,
  };
};

export const asyncMessagingTags = {
  UHCPP_LANDING_PAGE_CHAT_LOAD: (data) => {
    const filteredData = filterData(data);
    return {
      event: 'async-messaging-liveperson',
      data: filteredData,
    };
  },
  CONTACT_US_PAGE_LOAD: (data) => {
    const filteredData = filterData(data);
    return {
      event: 'async-messaging-liveperson',
      data: filteredData,
    };
  },
  UPDATE_PROVIDER_SELECTION: (data) => {
    const filteredData = filterData(data);
    return {
      event: 'async-messaging-change-liveperson',
      data: filteredData,
    };
  },
  PRODUCT_LIVE_CHAT: (data) => {
    const filteredData = filterData(data);
    return {
      event: 'async-messaging-liveperson',
      data: filteredData,
    };
  },
};
